var _QueueClass_data, _QueueClass_size;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
class QueueClass {
    constructor() {
        _QueueClass_data.set(this, []);
        _QueueClass_size.set(this, 0);
    }
    get isEmpty() {
        return this.size === 0;
    }
    get size() {
        return __classPrivateFieldGet(this, _QueueClass_size, "f");
    }
    dequeue() {
        __classPrivateFieldSet(this, _QueueClass_size, __classPrivateFieldGet(this, _QueueClass_size, "f") - 1, "f");
        return __classPrivateFieldGet(this, _QueueClass_data, "f").pop();
    }
    enqueue(value) {
        __classPrivateFieldSet(this, _QueueClass_size, __classPrivateFieldGet(this, _QueueClass_size, "f") + 1, "f");
        __classPrivateFieldGet(this, _QueueClass_data, "f").unshift(value);
    }
}
_QueueClass_data = new WeakMap(), _QueueClass_size = new WeakMap();
export const createQueue = () => new QueueClass();
